import { render, staticRenderFns } from "./Fileuphead.vue?vue&type=template&id=68d6dc34"
import script from "./Fileuphead.vue?vue&type=script&lang=js"
export * from "./Fileuphead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports